/**
 * Carte formulaire pour les générateurs IA
 * Flux vertical — étapes empilées
 */

import React from 'react'
import { Stack, Button, Layer } from '@carbon/react'
import type { CarbonIconType } from '@carbon/icons-react'
import styles from './AiGeneratorFormCard.module.scss'

export interface AiGeneratorFormCardProps {
  title: string
  icon: CarbonIconType
  children: React.ReactNode
  className?: string
}

export function AiGeneratorFormCard({
  title,
  icon: Icon,
  children,
  className = '',
}: AiGeneratorFormCardProps) {
  const steps = React.Children.toArray(children).filter(Boolean)

  return (
    <Layer className={`${styles.card} ${className}`}>
      <div className={styles.header}>
        <div className={styles.iconWrap}>
          <Icon size={20} />
        </div>
        <h2 className={styles.title}>{title}</h2>
      </div>
      <div className={styles.steps}>
        {steps.length > 0 && <div className={styles.step}>{steps[0]}</div>}
        <div className={styles.stepsRow}>
          {steps.slice(1, 3).map((child, i) => (
            <div key={i + 1} className={styles.step}>
              {child}
            </div>
          ))}
        </div>
        {steps.slice(3).map((child, i) => (
          <div key={i + 3} className={styles.step}>
            {child}
          </div>
        ))}
      </div>
    </Layer>
  )
}

export interface AiFormStepProps {
  step: number
  label: string
  children: React.ReactNode
}

export function AiFormStep({ step, label, children }: AiFormStepProps) {
  return (
    <div className={styles.stepContent}>
      <div className={styles.stepLabel}>
        <span className={styles.stepNumber}>{step}</span>
        <span className={styles.stepText}>{label}</span>
      </div>
      <div className={styles.stepBody}>{children}</div>
    </div>
  )
}

export interface AiGenerateButtonProps {
  onClick: () => void
  disabled: boolean
  isLoading: boolean
  label: string
  loadingLabel?: string
  icon?: CarbonIconType
}

export function AiGenerateButton({
  onClick,
  disabled,
  isLoading,
  label,
  loadingLabel = 'Génération...',
  icon: Icon,
}: AiGenerateButtonProps) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      kind="primary"
      size="lg"
      renderIcon={Icon}
      className={styles.generateButton}
    >
      {isLoading ? loadingLabel : label}
    </Button>
  )
}
